export const conjunctionList = (values: string[], and: string) => {
  return values.join(', ').replace(/, ([^,]*)$/, ` ${and} $1`);
};
